// extracted by mini-css-extract-plugin
module.exports = {"container":"ManCards_container__30P7x","containerMob":"ManCards_containerMob__c7ZaV","row1":"ManCards_row1__3kdFL","row2":"ManCards_row2__2yv_P"};